import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { QUERY_TIME } from "constants/time";
import { getKdsConfigInfo, KdsConfigInfoReq, KdsConfigInfoRes } from "../services/kdsService";

type optionProps = { enabled?: boolean };

export const useKdsConfigQuery = (
  params: KdsConfigInfoReq,
  options: optionProps = {}
): UseQueryResult<API.DefaultResponse<KdsConfigInfoRes>> => {
  const isEnabled = options.enabled ?? true;

  return useQuery({
    queryKey: ["kdsConfigInfo"],
    queryFn: () => getKdsConfigInfo(params),
    enabled: isEnabled && !!params.rootStore,
    staleTime: QUERY_TIME.THIRTY_SECONDS,
    cacheTime: QUERY_TIME.ONE_MINUTE,
    retry: 3,
  });
};
